import React from 'react'

export default function Page() {
  return (
    // <div className="max-width-90p">
    <div>
      <h1>Blog</h1>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2026_05_13">
          <div>
            <p className='right i'>13/05/2026 11:09 - Rodrigo Centurión</p>
            <h2>Gracias, Rugby Data Paraguay</h2>
            <hr />
            <p>Hoy quiero escribir unas palabras muy especiales para todos los que formaron parte de este proyecto durante tantos años.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_09_14">
          <div>
            <p className='right i'>14/09/2024 12:27 - Horacio Ariel Garcia Cabrera</p>
            <h2>Rugby Femenino - Este Domingo se juega la ultima fecha antes de las rondas finales</h2>
            <hr />
            <p>Ultima fecha del torneo seven femenino de la URP, para algunas correcciones o información que desconocía sobre el formato del torneo femenino, este torneo clausura se ha cambiado el formato, ya que anteriormente todos los torneos eran de rondas todos contra todos.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_09_02">
          <div>
            <p className='right i'>02/09/2024 15:08 - Horacio Ariel Garcia Cabrera</p>
            <h2>Fecha 2 en Pre Intermedia y M14 Metro, Fecha 3 en Femenino! 🏉🇵🇾</h2>
            <hr />
            <p>En un vibrante partido con trys y marcador de ida y vuelta el domingo 1 de septiembre, los Toros de Fernando de la Mora Rugby visitaron a su par de Old King Club en el estadio Héroes de Curupayty en el comité Olímpico paraguayo para dar continuidad a la segunda fecha del torneo clausura en la División Pre intermedia.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_08_29">
          <div>
            <p className='right i'>29/08/2024 08:33 - Adry Decoud</p>
            <h2>Inicia el torneo oficial en todas las divisiones con record en partidos disputados en todo el pais! 🏉🇵🇾</h2>
            <hr />
            <p>Histórico y sin precedentes en Paraguay: 54 partidos disputados entre categorías M13, M14, M16, M18, Intermedia, Primera y Femenino, tanto en Asunción como en el interior del país. El rugby se juega en la capital y en el interior, abarcando todas las divisiones, con árbitros paraguayos certificados por World Rugby.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_08_26">
          <div>
            <p className='right i'>26/08/2024 10:40 - Horacio Ariel Garcia Cabrera</p>
            <h2>Toros vs Jararás 🏉🇵🇾 Fecha 1 del Pre Intermedia Metro</h2>
            <hr />
            <p>En una siesta atípica para nuestro país, con un día soleado y menos de 15°C se dio inicio al torneo de la Pre Intermedia Metro de la URP y en esta ocasión le toco la oportunidad a los Toros de Fernando de la Mora enfrentarse de visita a los locales de Jararas en el estadio Héroes de Curupayty de la URP en el Comité Olímpico Paraguayo.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_08_25">
          <div>
            <p className='right i'>25/08/2024 21:02 - Rodrigo Centurión</p>
            <h2>La inteligencia artificial y el rugby, ¿qué tienen que ver?</h2>
            <hr />
            <p>En el último año, la inteligencia artificial (IA) se ha convertido en un término omnipresente en nuestras vidas. Desde aplicaciones que predicen el clima hasta asistentes virtuales que responden nuestras preguntas, la IA está en todas partes, incluso en áreas que nunca hubiéramos imaginado, como el rugby.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_08_19">
          <div>
            <p className='right i'>19/08/2024 20:30 - Horacio Ariel Garcia Cabrera</p>
            <h2>Fecha 2 del Rugby Seven Femenino!! 🎉🏉🇵🇾</h2>
            <hr />
            <p>El Domingo 18 de agosto se llevo a cabo la segunda fecha del torneo clausura del seven femenino de la URP, en esta ocasión el Fernando de la Mora Fem Rugby tuvieron la dura tarea de enfrentarse al campeón y vicecampeón del torneo apertura, primero se enfrentaron con Santa Clara el 2° en el torneo apertura y luego contra Old King el campeón del apertura.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2024_08_05">
          <div>
            <p className='right i'>05/08/2024 17:30 - Horacio Ariel Garcia Cabrera</p>
            <h2>Empezó el torneo clausura de Rugby Seven Femenino!! 🎉🏉🇵🇾</h2>
            <hr />
            <p>Este domingo 4 de agosto empezó el torneo clausura de Rugby Seven Femenino, torneo organizado por la Union de Rugby del Paraguay (URP), este año se cuenta con 14 equipos de todos los rincones del país y por 3 año consecutivo se presenta el Fernando de la Mora Rugby Fem en este torneo.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2023_10_22">
          <div>
            <p className='right i'>22/10/2023 18:22 - Rodrigo Centurión</p>
            <h2>CURDA campeón del torneo oficial URP 2023 🎉🏉🇵🇾</h2>
            <hr />
            <p>En una emocionante batalla contra San José, el equipo CURDA logró imponerse con un marcador de 29 a 25 en el Estadio "Héroes del Curupayty" el pasado sábado 21 de octubre de 2023</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2023_09_22">
          <div>
            <p className='right i'>22/09/2023 23:59 - Rodrigo Centurión</p>
            <h2>Se habilita la sección BLOG</h2>
            <hr />
            <p>Descubre el emocionante mundo del rugby en Paraguay en nuestro nuevo blog! Noticias, historias inspiradoras, consejos y mucho más para los amantes del deporte.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2023_09_16">
          <div>
            <p className='right i'>16/09/2023 16:33 - Rodrigo Centurión</p>
            <h2>Ya se encuentra disponible la página web de Rugby Data Paraguay</h2>
            <hr />
            <p>¡La página web de Rugby Data Paraguay está en línea! Descubre datos, estadísticas y noticias sobre el rugby en Paraguay. 🏉🇵🇾</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2023_09_16">
          <div>
            <p className='right i'>15/09/2023 20:00 - Rodrigo Centurión</p>
            <h2>Lanzamos la comunidad de WhatsApp de Rugby en Paraguay</h2>
            <hr />
            <p>¡Únete a nuestra comunidad de WhatsApp de Rugby en Paraguay! Colabora, comparte ideas y fortalece nuestra pasión por el rugby. 🏉🇵🇾</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2023_09_15">
          <div>
            <p className='right i'>15/09/2023 19:00 - Rodrigo Centurión</p>
            <h2>¡1 año de Rugby Data Paraguay!</h2>
            <hr />
            <p>¡Celebramos un año de Rugby Data Paraguay! Una aventura que comenzó el 15 de septiembre de 2022. ¡Únete a nuestra comunidad rugbística! 🏉🇵🇾</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2023_08_04">
          <div>
            <p className='right i'>04/08/2023 21:00 - Rodrigo Centurión</p>
            <h2>Inicia el campeonato oficial URP 2023</h2>
            <hr />
            <p>¡El campeonato oficial de la URP comienza el 5 de agosto! Los resultados de los partidos se publicarán exclusivamente en nuestra página web. 🏉🇵🇾</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2022_12_02">
          <div>
            <p className='right i'>02/12/2022 07:31 - Rodrigo Centurión</p>
            <h2>¡Llegamos a 4.000 seguidores!</h2>
            <hr />
            <p>Hemos alcanzado 4.000 seguidores en medio de desafíos, aprendizajes y la unión de una comunidad apasionada por el rugby en Paraguay. 🎉🏉🇵🇾</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2022_11_11">
          <div>
            <p className='right i'>11/11/2022 21:00 - Rodrigo Centurión</p>
            <h2>Rugby en Juegos Universitarios UNA 2022</h2>
            <hr />
            <p>Descubre el emocionante rugby en los Juegos Universitarios UNA 2022. Resultados, destacados y apoyo a nuestros talentosos equipos universitarios. 🏉🇵🇾</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2022_09_30">
          <div>
            <p className='right i'>30/09/2022 08:54 - Rodrigo Centurión</p>
            <h2>Primera publicación en Instagram</h2>
            <hr />
            <p>¡Únete a nuestra nueva aventura en Instagram! Rugby Data Paraguay te trae momentos destacados, perfiles de jugadores y noticias emocionantes. ¡Síguenos para no perderte nada! 🏉🇵🇾 #RugbyInstagram</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button" href="/blog/2022_09_15">
          <div>
            <p className='right i'>15/09/2022 11:30 - Rodrigo Centurión</p>
            <h2>El inicio de un gran proyecto: Rugby Data Paraguay</h2>
            <hr />
            <p>Rugby Data Paraguay: Tu fuente de estadísticas, noticias y perfiles de jugadores. Únete a nuestra comunidad rugbística hoy mismo.</p>
          </div>
        </a>
      </div>

    </div>
  )
}